module.exports = __webpack_public_path__ + "static/hsCube-645b7432e7b72e7259e9019c3a5611f1.jpg";